
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { getStaMaintenanceRecord } from "@/api/api-operation-service";
@Component
export default class PiSiteSteps extends Vue {
  @Prop({ default: "" }) private staPkId!: string;

  private recordList: objAny[] = [];
  async getStaMaintenanceRecord(): Promise<void> {
    const ret = await getStaMaintenanceRecord({
      staPkId: this.staPkId
    });
    if (ret.status === this.$config.apiStatus) {
      this.recordList = ret.data;
    }
  }

  mounted(): void {
    this.getStaMaintenanceRecord();
  }
}
